<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`"
      class="mx-auto c-click"
      width="100%"
      height="100%"
      @click.native="onClick"
    >
      <div class="c-card" v-show="!matLoading" :class="type">
        <div class="c-mat" :class="!loading ? 'c-hide' : 'c-show'">
          <img ref="img" class="c-dummy" :src="$imageUtils.CLEAR_MAT_DATA" @load="matLoading = false" />
        </div>
        <div class="c-ab c-flex ac jc c-icon" :class="!loading ? 'c-hide' : 'c-show'">
          <v-icon color="white" :size="iconSize">{{ isMovie ? 'mdi-play-box-outline' : 'mdi-image-outline' }}</v-icon>
        </div>
        <div v-if="activated" class="c-flex ac jc c-img-d">
          <c-img v-if="src" :src="src" @load="loading = false" class="c-trn c-img" :style="calcRotate" />
        </div>
        <div v-if="isMovie" class="c-play c-sdw">
          <v-icon v-if="!movieTime" color="white">mdi-play</v-icon>{{ movieTime }}
        </div>
        <div class="c-time c-trn" :class="alwaysTime || hover ? 'c-show' : 'c-hide'">
          {{ formatTime }}
        </div>
        <!--         <div v-if="ym" class="c-yearmonth en-date">
          <div class="c-m">{{moment.format('MMMM')}}</div>
          <div class="c-y">{{moment.format('YYYY')}}</div>
        </div>
 -->
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import { CONST } from '../../constant';

export default {
  props: {
    item: { required: true, type: Object },
    width: { required: true, type: Number },
    type: { required: false, type: String, default: 'thumb' },
    alwaysTime: { required: false, type: Boolean, default: false },
    ym: { required: false, type: Number, default: 0 },
    dateFormat: { required: false, type: String, default: 'common.moment.d' },
    smallIcon: { required: false, type: Boolean, default: false },
  },
  computed: {
    size() {
      return this.$utils.getSizeFromSize(this.item.thumb_wh, this.width, this.devicePixelRatio, 'm', false);
    },
    src: function() {
      if (this.size == 'original') return this.appendGuest(`/file/${this.item.id}`);
      return this.appendGuest(`/thumb/${this.size}/${this.item.id}`);
    },
    useTooltip: function() {
      return !this.stopTooltip && this.item && this.item.ts;
    },
    iconSize: function() {
      if (this.smallIcon) return 30;
      if (this.type == 'thumb') return 30;
      if (this.type == 'pickup') return 50;
      if (this.type == 'original') return 60;
      throw 'unknown size:' + this.size;
    },
    isMovie: function() {
      return !!CONST.accept_album_movie_exts[this.item.extension];
    },
    formatTime: function() {
      return this.item.ts
        ? this.$moment
            .unix(this.item.ts)
            .locale('en')
            .format('ddd DD HH:mm')
        : '';
    },
    calcRotate: function() {
      return `transform:rotate(${this.item.rotate}deg)`;
    },
    movieTime: function() {
      if (!this.item.movie_time) return '';
      var s = Number(this.item.movie_time.split('.')[0]);
      var d = this.$moment.duration(s, 'seconds');
      var sec = d.seconds();
      var min = d.minutes();
      return (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
    },
  },
  data() {
    return {
      loading: true,
      matLoading: true,
      activated: false,
      needActivate: true,
    };
  },
  methods: {
    appendGuest: function(path) {
      if (this.isGuest) return `${path}/${window.$G}/guest`;
      return path;
    },
    activate: function(range) {
      var img = this.$refs.img;
      if (!img) {
        console.log(`${this.item.id} size=${this.size} skip activate!`);
        return false;
      }
      var rect = img.getBoundingClientRect();
      if (rect.bottom == rect.top) {
        return false;
      }
      if (rect.bottom >= 0 - range && rect.top <= this.h + range) {
        // console.log(`${this.item.id} size=${this.size} t=${rect.top} b=${rect.bottom} h="${this.h}" activated!`);
        this.activated = true;
        this.needActivate = true;
        return !this.loading;
      }
      // OK not to activate when out of range.
      if (rect.bottom < 0 - this.h || rect.top > this.h + this.h) {
        this.needActivate = false;
        this.loading = true;
        this.activated = false;
      } else {
        this.needActivate = true;
      }
      return true;
    },
    onClick: function() {
      this.$emit('click', this.item);
    },
  },
};
</script>

<style scoped>
.c-click {
  cursor: pointer;
  cursor: hand;
}
.c-show {
  opacity: 1 !important;
}
.c-hide {
  opacity: 0 !important;
}
.c-card {
  padding: 0;
  margin: 0;
  position: relative;
  color: #fff;
  overflow: hidden;
}
.c-mat {
  background-color: #ddd;
}
.c-dummy {
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
}
.c-dummy img {
  min-width: calc(100% + 6px);
  min-height: calc(100% + 6px);
  max-width: calc(100% + 6px);
  max-height: calc(100% + 6px);
}
.c-ab {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.c-icon {
}
.c-sdw {
  text-shadow: #333 1px 1px 3px;
}

.c-time {
  text-shadow: #000 1px 1px 2px;
  position: absolute;
  bottom: 0;
  right: 0;
  font-weight: 200;
}
.thumb .c-time {
  font-size: 12px;
  margin: 0 10px 5px 0;
  color: rgba(255, 255, 255, 0.9);
}
.pickup .c-time {
  font-size: 16px;
  margin: 0 20px 10px 0;
  color: rgba(255, 255, 255, 0.9);
}

.c-play {
  text-shadow: #000 1px 1px 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: 200;
}
.thumb .c-play {
  font-size: 12px;
  margin: 0 0 5px 10px;
  color: rgba(255, 255, 255, 0.9);
}
.thumb .c-play i {
  font-size: 15px;
  opacity: 0.9;
}
.pickup .c-play {
  font-size: 16px;
  margin: 0 0 10px 25px;
  color: rgba(255, 255, 255, 0.9);
}
.pickup .c-play i {
  font-size: 20px;
  opacity: 0.9;
}
.size-original .c-play {
  font-size: 24px;
}
.size-original .c-play i {
  font-size: 24px;
}

.c-img-d {
  position: absolute;
  top: -3px;
  left: -3px;
  padding: 0;
  margin: 0;
  width: calc(100% + 6px);
  height: calc(100% + 6px);
}
.c-img {
  max-width: 100%;
  max-height: 100%;
}
/*
  .c-yearmonth {
    position: absolute;
    right: 25px;
    top: 60px;
    transform: translateY(-50%);
    color: rgba(255,255,255,1);
    text-shadow: #000 1px 1px 2px;
    flex-direction: column;
    align-items: flex-start;
  }
  .c-y {
    font-size: 18px;
    margin-top: -5px; 
    text-align: left;
  }
  .c-m {
    font-size: 30px;
    text-align: left;
  }
  */
</style>
